import {FormGroup} from "@angular/forms";

export class ValidationDetail {
  constructor(public formGroup: FormGroup,
              public labels: Map<string, string>,
              public reset = false) {
  }
}
